/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetUsersProfileQueryResponse, GetUsersProfile400 } from '../entities/GetUsersProfile'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetUsersProfileUrl() {
  return `/users/profile` as const
}

/**
 * @description Получение профиля пользователя
 * @summary Получение профиля пользователя
 * {@link /users/profile}
 */
export async function getUsersProfile(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetUsersProfileQueryResponse, ResponseErrorConfig<GetUsersProfile400>, unknown>({
    method: 'GET',
    url: getGetUsersProfileUrl().toString(),
    ...requestConfig,
  })
  return res.data
}